export { createI18nSettings } from './create-i18n-settings';
